import { render, staticRenderFns } from "./RendSigTp.vue?vue&type=template&id=b15f1bc0&"
import script from "./RendSigTp.vue?vue&type=script&lang=js&"
export * from "./RendSigTp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports